import React from 'react';
import { Alert, Spinner, Table, Container, Row, Col } from 'react-bootstrap';
import { PageStatus } from 'enums';
import { Show } from 'Layout';
import { SurveysAPI } from "../../API";
import moment from "moment";
import { formatSmartDate } from "../../Utils/DateFormatter";




export default class PartnerSurvey extends React.Component<any, any> {
    constructor(props) {
        super(props);
        this.state = {
            survey: null,
            status: PageStatus.None,
            error: null,
            deviceBlocked: false,
            deviceMessage: '',
            allowedDevices: '',
            detectedDevice: '',
        };
    }

    componentDidMount() {
        const fullUrl = window.location.href;
        const queryString = fullUrl.split('?')[1] || '';
        const urlSearchParams: any = new URLSearchParams(queryString);
        const surveyId = urlSearchParams.get('surveyid');
        const userId = urlSearchParams.get('rid');
        const sid = urlSearchParams.get('svid');
        const partnerId = urlSearchParams.get('partnerid');
        const uniqueCode = urlSearchParams.get('uniqueCode');
        const params = {};
        for (const [key, value] of urlSearchParams.entries()) {
            if(userId !== value || surveyId !== value || partnerId !== value) {
                params[key] = value;
            }
        }
        if (!!surveyId && !!userId && partnerId) {
            this.fetchSurvey(surveyId, userId, partnerId, sid, params, uniqueCode);
        }
    }

    fetchSurvey(surveyId, userId, partnerId, sid, params, uniqueCode) {
        let obj = { surveyId, userId, partnerId, sid, params };
        if(uniqueCode) { obj[uniqueCode] = uniqueCode };
        Promise.resolve()
            .then(() => this.setState({ status: PageStatus.Loading }))
            .then(() => SurveysAPI.surveyPartner(obj))
            .then((survey) => {
                // Device-compatibility block: backend returns a structured object
                // instead of a redirect URL when the panelist is on an unsupported
                // device. No PartnerUsers row is created, so the panelist can open
                // the same link again on a supported device.
                if (survey && typeof survey === 'object' && (survey as any).deviceBlocked) {
                    this.setState({
                        status: PageStatus.Loaded,
                        deviceBlocked: true,
                        deviceMessage: (survey as any).message || '',
                        allowedDevices: (survey as any).allowed || '',
                        detectedDevice: (survey as any).detected || '',
                    });
                    return;
                }
                if(survey) {
                    window.location.href = survey;
                    this.setState({ survey, status: PageStatus.Loaded });
                }
            })
            .catch((error) => {
                this.setState({ status: PageStatus.Error, error: error.message });
            });
    }


    render() {
        return (
            <div style={{ background: '#f5f5f5', border: '2px solid #ddd', padding: '20px'}}>
                <Show when={this.state.status === PageStatus.Loading}>
                    <Container className="d-flex justify-content-center mt-5">
                        <Spinner animation="border" variant="primary" />
                    </Container>
                </Show>

                <Show when={this.state.deviceBlocked}>
                    <Container className="text-center mt-5" style={{ maxWidth: 560 }}>
                        <h2>Device Not Supported</h2>
                        <p className="mt-3" style={{ fontSize: '1.1rem' }}>{this.state.deviceMessage}</p>
                        <p className="text-muted">
                            Detected device: <strong>{this.state.detectedDevice || 'unknown'}</strong>.
                            Allowed: <strong>{this.state.allowedDevices || '-'}</strong>.
                        </p>
                        <p className="text-muted">Please open this link on a supported device — no attempt has been recorded.</p>
                    </Container>
                </Show>

                <Show when={this.state.status === PageStatus.Loaded && !!this.state.survey && this.state.survey.surveysDetails}>
                    <Container className='text-center mt-5'>
                        <h1>Completed</h1>
                    </Container>

                    {this.state.survey?.surveysDetails ?
                        <Container className="d-flex justify-content-center mt-5">
                            <Table bordered>
                                <thead>
                                <tr>
                                    <th scope="col">S No</th>
                                    <th scope="col">User Name</th>
                                    <th scope="col">Survey Name</th>
                                    <th scope="col">Points</th>
                                    <th scope="col">Date & Time</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <th scope="row">1</th>
                                    <td>{this.state.survey.user.firstName} {this.state.survey.user.lastName}</td>
                                    <td>{this.state.survey.surveysDetails.survey.name}</td>
                                    <td>{this.state.survey.surveysDetails.survey.ceggPoints}</td>
                                    <td>{formatSmartDate(this.state.survey.updatedAt)}</td>
                                </tr>
                                </tbody>
                            </Table>
                        </Container>
                        : null
                    }

                    {this.state.survey?.surveysDetails ?
                        <Container className="d-flex justify-content-center mt-5">
                            <Row>
                                <Col>
                                    <strong>Disclaimer: </strong>
                                    <p dangerouslySetInnerHTML={{
                                        __html: this.state.survey?.surveysDetails.survey.disclaimer || 'NA',
                                    }} />
                                </Col>
                            </Row>
                        </Container>
                        : null
                    }

                    <Container className="d-flex justify-content-center mt-5">
                        <Alert
                            variant="danger"
                            show={this.state.status === PageStatus.Error}
                        >
                            {this.state.error}
                        </Alert>
                    </Container>
                </Show>
            </div>

        );
    }
}

